import useCartQuantity from './hooks/useCartQuantity';
import { useTranslation } from 'react-i18next';
import { WineWidgetModel } from '../../../models/WineWidgetModel';
import { useColorContext } from 'shared-widget-components/src/providers/ColorsProvider';

interface CartComponentProps {
  wine: WineWidgetModel;
}

/**
 * Cart component
 * @param wine - wine
 * @returns - cart component
 */

export const CartComponent = ({ wine }: CartComponentProps) => {
  const { buttonColor, buttonTextColor } = useColorContext();
  const { t } = useTranslation();
  const { increment, decrement, cartQuantity } = useCartQuantity({ wine });

  // @ts-ignore
  const isAdmin = window.isAdminPage;

  // the minus button should be disabled if the cart quantity is equal to the minimum quantity
  const isMinusButtonDisabled = cartQuantity === wine.minimumCartQuantity;
  // the plus button should be disabled if the cart quantity is equal to the maximum quantity
  const isPlusButtonDisabled = cartQuantity === wine.maximumCartQuantity || cartQuantity === wine.availableQuantity;

  // function to add the wine to the cart
  const addToCart = () => {
    //@ts-ignore
    if (isAdmin) return;
    //@ts-ignore
    if (!cartHandler) return;
    //@ts-ignore
    cartHandler && cartHandler.addOrUpdateCart(wine.productVariantId);
  };

  return (
    <div className={`flex w-full min-[350px]:h-[35px] md:h-[40px] mt-auto group self-end`}>
      <div className='flex w-2/5 justify-between items-center rounded-l-md border border-r-0 border-slate-400 duration-200 transition-opacity overflow-hidden'>
        <button
          type='button'
          onClick={decrement}
          disabled={isMinusButtonDisabled}
          className={`${
            isMinusButtonDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
          } min-[350px]:w-[35px] min-[350px]:h-[35px] md:h-[40px] md:w-[40px] pb-[4px] text-[24px] font-semibold flex justify-center items-center rounded-md outline-none focus:outline-none active:outline-none bg-white hover:text-opacity-80 duration-200 transition-opacity`}
        >
          -
        </button>
        <p className='font-body font-medium flex justify-center items-center'>{cartQuantity}</p>
        <button
          type='button'
          onClick={increment}
          disabled={isPlusButtonDisabled}
          className={`${
            isPlusButtonDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
          } min-[350px]:w-[35px] min-[350px]:h-[35px] md:h-[40px] md:w-[40px] pb-[4px] text-[24px] font-semibold flex justify-center items-center rounded-l-md outline-none focus:outline-none active:outline-none bg-white hover:text-opacity-80 duration-200 transition-opacity`}
          style={{ color: buttonColor }}
        >
          +
        </button>
        <input
          hidden
          type='number'
          onChange={() => {}}
          data-quantity-id={wine.productVariantId}
          data-ga-name={wine.title}
          data-ga-variant={wine.title}
          data-ga-category='Borok'
          data-ga-price={wine.discount ? wine.currentPrice : wine.basePrice}
          data-ga-brand={wine.manufacturerName}
          value={cartQuantity}
        />
      </div>
      <button
        type='button'
        className={`w-3/5 font-bold rounded-r hover:opacity-80 duration-200 transition-opacity outline-none focus:border-none focus:outline-none`}
        style={{ backgroundColor: buttonColor, color: buttonTextColor }}
        onClick={addToCart}
      >
        {t('wineWidget.cart')}
      </button>
    </div>
  );
};
